<template>
  <div>
    <div class="hidden md:block">
      <div
        v-if="show"
        class="fixed top-[62px] left-0 w-full h-full bg-transparent"
        qa-tag="nav-menu-overlay"
        @click="$emit('hide', false)"
      ></div>
      <transition name="nav-grow-fade">
        <div
          v-show="show"
          class="absolute flex flex-col items-center bg-white rounded-lg gap-ds-sm shadow-rebrand mt-ds-sm overflow-hidden p-ds-lg"
          :class="[navDimensions]"
        >
          <slot />
        </div>
      </transition>
    </div>
    <div class="md:hidden">
      <transition name="nav-slide-in">
        <div
          v-if="show"
          class="fixed flex flex-col items-center bg-white gap-ds-sm overflow-scroll px-ds-lg py-ds-ml inset-0 z-[70] cursor-pointer"
        >
          <img
            :src="`/content-static/navigation-menu/close.svg`"
            alt="Close"
            class="fixed-size ml-auto z-[50]"
            qa-tag="nav-menu-close"
            @click="$emit('hide', false)"
            loading="lazy"
          />
          <slot />
        </div>
      </transition>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { getScreenWidth } from "~/scripts/useful-functions"

export default defineComponent({
  name: "NavMenu",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showingAllServices: {
      type: Boolean,
      default: false
    },
    helpCentre: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      screenWidth: null as null | number
    }
  },
  computed: {
    navDimensions() {
      if (this.showingAllServices) {
        return "w-[600px] h-[520px]"
      } else if (this.helpCentre) {
        return "w-[410px] h-[560px]"
      } else {
        return "w-[350px] h-auto"
      }
    }
  },
  watch: {
    show() {
      const chatWidget = document.getElementById("chat-widget-container")
      const responseIqWidget = document.getElementById("responseiq-app-container")

      if (this.screenWidth && this.screenWidth < 768) {
        if (chatWidget) {
          chatWidget.style.display = this.show ? "none" : "block"
        }
        if (responseIqWidget) {
          responseIqWidget.style.display = this.show ? "none" : "block"
        }
        if (this.show) {
          this.preventBodyScroll()
        } else {
          this.restoreBodyScroll()
        }
      }
    }
  },
  mounted() {
    document.addEventListener("keydown", this.escapeClosePopup)
    this.screenWidth = getScreenWidth()
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.escapeClosePopup)
  },
  methods: {
    escapeClosePopup(e) {
      if (e.key === "Escape" && this.show) {
        this.$emit("hide", false)
      }
    },
    preventBodyScroll() {
      // smooth scroll to top before showing menu
      window.scrollTo({ top: 0, behavior: "smooth" })
      // small delay to prevent jarring transition
      setTimeout(() => {
        document.body.style.overflow = "hidden"
        document.body.style.position = "fixed"
      }, 300)
    },

    restoreBodyScroll() {
      document.body.style.overflow = ""
      document.body.style.position = ""
    }
  }
})
</script>
